import PropTypes from 'prop-types';
import Footer from '../common/Footer';
import HealthChatBot from '../HealthChatBot';
import SiteHeader from '../common/SiteHeader';


const Layout = ({ children }) => {
  // const { variant } = useNavbar();

  return (
    <div className="flex flex-col min-h-screen">
      <SiteHeader />
      <main className="flex-grow">
        {children}
      </main>
      <HealthChatBot />
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;